import { DrawerBase } from 'bog-arcade-core-ui/core/DrawerBase';
import { GAME_APPLICATION_TYPE_STATE } from '../../stateManagment';

export class BaseElementDrawer extends DrawerBase {
  constructor(applications) {
    super();
    this.applications = applications;
  }

  get application() {
    return this.applications[GAME_APPLICATION_TYPE_STATE.getValue()];
  }

}
